module.exports = __webpack_public_path__ + "img/hr-deepwater4.547cc6c0.png";